import { render, staticRenderFns } from "./pullUpReload.vue?vue&type=template&id=b0312efc&scoped=true"
import script from "./pullUpReload.vue?vue&type=script&lang=js"
export * from "./pullUpReload.vue?vue&type=script&lang=js"
import style0 from "./pullUpReload.vue?vue&type=style&index=0&id=b0312efc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0312efc",
  null
  
)

export default component.exports